import React from 'react';
import SlidingPanel from 'react-sliding-side-panel';
import { IconEditImg } from '../../img';
// import DatePicker from 'react-datepicker';
import ReactQuill from 'react-quill';
import { IconClose } from '../../img';
import { Container, Draggable } from 'react-smooth-dnd';
import Dropdown from 'react-dropdown';

//for  
const toolbarModule = {
  container: [
    [{ 'align': [] }],
    ['bold', 'italic', 'underline'],
    ['link', 'clean'],
  ],
};

const modulesQuill = {
  toolbar: toolbarModule
};

const formatsQuill = [
  'header', 'font', 'size',
  'bold', 'italic', 'underline', 'strike', 'blockquote',
  'list', 'bullet', 'indent', 'align',
  'link', 'image', 'background', 'color',
];

const inputOptn = [
  { value: 'textbox', label: 'Text box' },
  { value: 'text_area', label: 'Text area' },
  { value: 'dropdown', label: 'Dropdown' },
  { value: 'radio_button', label: 'Radio button' },
  { value: 'checkbox', label: 'Checkbox' },
  { value: 'star_rating', label: 'Star rating' },
  { value: 'datepicker', label: 'Date picker' },
  { value: 'range_slider', label: 'Range slider' }
];

let btnPosition = [
  { value: 'left', label: 'Left' },
  { value: 'center', label: 'Center' },
  { value: 'right', label: 'Right' },
];

let arrCategory = [];

let arrfled = {
  tool_team_showcase: 'Name',
  tool_pricing: 'Plan name'
};

let arrsled = {
  tool_team_showcase: 'Position',
  job_board: 'Location',
  tool_number_animation: 'Prefix'
};

let arrtled = {
  tool_team_showcase: 'Location',
  tool_pricing: 'Plan Detail',
  tool_restaurant: 'Price',
  tool_number_animation: 'Postfix'
};

let arrfrtled = {
  tool_team_showcase: 'Description',
  tool_pricing: 'Pricing'
};

let arrfftled = {
  tool_pricing: 'Discount'
};


const StoryWidgetDataCard = ({
  cnf,
  openCloseStoryData,
  openCloseStoryDataPanel,
  objStoryData,
  AddfieldinArw,
  ClonefieldinArw,
  handleArrayChange,
  openIconModel,
  handleAddUpdateWidget,
  deletefieldinArw,
  handleEditorFocus,
  wdtnm,
  jobSkillChips,
  removeChips,
  handleInputchange,
  handleEnterEvent,
  handleArrayDrag,
  handleChildArrayChange,
  AddfieldinChildArw,
  arrName,
  widgetDataValidator
}) => {

  if (cnf && cnf.tlsctarr != undefined) {
    arrCategory = [];
    for (let i = 0; i < cnf.tlsctarr.length; i++) {
      const _arr = cnf.tlsctarr[i];
      arrCategory.push({ value: _arr.ct_id, label: _arr.arrfl });
    }
  }
  return (
    <div className="card-slider-dataset mt-15">
      <div className="tabs-layout-content">
        {/* Category array */}
        {cnf && cnf.tlsctarr != undefined &&
          <div className="card card-editor card-template">
            <div className="card-editor-block p-0">
              <label className="card-editor-title">Category</label>
              <div className="customize-list">
                {cnf.tlsctarr.length > 0 ?
                  <div className="drag-slider-box">
                    <Container dragClass="opacity-ghost" dropClass="opacity-ghost-drop" onDrop={e => handleArrayDrag(cnf.tlsctarr, 'tlsctarr', e)}>
                      {
                        cnf.tlsctarr.map((val, key) => {
                          return (
                            <Draggable key={key}>
                              <div className="draggable-item draggable-item-sldrdata editor-rowbdr-btm">
                                <div className="draggable-control-icon">
                                  <svg id="icon-move" xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10">
                                    <path id="Path_14666" data-name="Path 14666" d="M1,4A.945.945,0,0,1,2,5,.945.945,0,0,1,1,6,.945.945,0,0,1,0,5,.945.945,0,0,1,1,4Z" />
                                    <path id="Path_14667" data-name="Path 14667" d="M1,0A.945.945,0,0,1,2,1,.945.945,0,0,1,1,2,.945.945,0,0,1,0,1,.945.945,0,0,1,1,0Z" />
                                    <path id="Path_14668" data-name="Path 14668" d="M1,8A.945.945,0,0,1,2,9a.945.945,0,0,1-1,1A.945.945,0,0,1,0,9,.945.945,0,0,1,1,8Z" />
                                    <path id="Path_14670" data-name="Path 14670" d="M6,0A.945.945,0,0,1,7,1,.945.945,0,0,1,6,2,.945.945,0,0,1,5,1,.945.945,0,0,1,6,0Z" />
                                    <path id="Path_14671" data-name="Path 14671" d="M6,4A.945.945,0,0,1,7,5,.945.945,0,0,1,6,6,.945.945,0,0,1,5,5,.945.945,0,0,1,6,4Z" />
                                    <path id="Path_14672" data-name="Path 14672" d="M6,8A.945.945,0,0,1,7,9a.945.945,0,0,1-1,1A.945.945,0,0,1,5,9,.945.945,0,0,1,6,8Z" />
                                  </svg>
                                </div>
                                <div className="draggable-data-col draggable-data-title">
                                  {
                                    val.arrfl ? val.arrfl : ''
                                  }
                                </div>
                                <div className="draggable-data-col draggable-data-action">
                                  <span className="btn-action nf-btn light-bg-icon btn-icon-20  tbl-action-dlt" onClick={() => openCloseStoryDataPanel(val, key, 'tlsctarr')}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12.414" height="7.4" viewBox="0 0 12.414 7.4">
                                      <path id="Path_14253" data-name="Path 14253" d="M6.207,98.725A7.744,7.744,0,0,0,.1,102.13a.491.491,0,0,0,0,.587,7.74,7.74,0,0,0,6.11,3.408,7.744,7.744,0,0,0,6.11-3.405.491.491,0,0,0,0-.587A7.74,7.74,0,0,0,6.207,98.725Zm.17,6.305A2.611,2.611,0,1,1,8.812,102.6,2.613,2.613,0,0,1,6.377,105.03Zm-.079-1.2a1.406,1.406,0,1,1,1.313-1.313A1.4,1.4,0,0,1,6.3,103.827Z" transform="translate(0 -98.725)" fill="#8392a5" />
                                    </svg>
                                  </span>
                                  <span className="btn-action nf-btn  btn-delete-light  light-bg-icon btn-icon-20 tbl-action-dlt" onClick={() => deletefieldinArw(key, 'tlsctarr')}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 176 192">
                                      <g id="Group_8307" data-name="Group 8307" transform="translate(-8)">
                                        <path id="Path_12759" data-name="Path 12759" d="M128,32V24A24.027,24.027,0,0,0,104,0H88A24.027,24.027,0,0,0,64,24v8H8V48H184V32ZM80,24a8.009,8.009,0,0,1,8-8h16a8.009,8.009,0,0,1,8,8v8H80Z" fill="#fb5360" />
                                        <path id="Path_12760" data-name="Path 12760" d="M30.467,170.651A23.976,23.976,0,0,0,54.321,192h83.358a23.976,23.976,0,0,0,23.854-21.35L174.272,56H17.728Zm87.561-99.316,15.944,1.33-8,96-15.944-1.33Zm-44.056,0,8,96-15.944,1.33-8-96Z" fill="#fb5360" />
                                      </g>
                                    </svg>
                                  </span>
                                </div>
                              </div>
                            </Draggable>
                          );
                        })
                      }
                    </Container>
                  </div>
                  :
                  <div>
                    <p className='text-center'>No record found</p>
                  </div>
                }
                <div className="text-center add-new-whatsapp-num mt-3">
                  <button type='button' className="nf-btn nf-btn-default" onClick={() => AddfieldinArw('tlsctarr')}>
                    Add new
                  </button>
                </div>
              </div>
            </div>
          </div>
        }
        {/* Data array */}
        {cnf && cnf.tlsdtarr != undefined &&
          <div className="card card-editor card-template">
            <div className="card-editor-block p-0">
              <label className="card-editor-title">Data</label>
              <div className="customize-list">
                {cnf.tlsdtarr.length > 0 ?
                  <div className="drag-slider-box">
                    <Container dragClass="opacity-ghost" dropClass="opacity-ghost-drop" onDrop={e => handleArrayDrag(cnf.tlsdtarr, 'tlsdtarr', e)}>
                      {
                        cnf.tlsdtarr.map((val, key) => {
                          return (
                            <Draggable key={key}>
                              <div className="draggable-item draggable-item-sldrdata editor-rowbdr-btm">
                                <div className="draggable-control-icon">
                                  <svg id="icon-move" xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10">
                                    <path id="Path_14666" data-name="Path 14666" d="M1,4A.945.945,0,0,1,2,5,.945.945,0,0,1,1,6,.945.945,0,0,1,0,5,.945.945,0,0,1,1,4Z" />
                                    <path id="Path_14667" data-name="Path 14667" d="M1,0A.945.945,0,0,1,2,1,.945.945,0,0,1,1,2,.945.945,0,0,1,0,1,.945.945,0,0,1,1,0Z" />
                                    <path id="Path_14668" data-name="Path 14668" d="M1,8A.945.945,0,0,1,2,9a.945.945,0,0,1-1,1A.945.945,0,0,1,0,9,.945.945,0,0,1,1,8Z" />
                                    <path id="Path_14670" data-name="Path 14670" d="M6,0A.945.945,0,0,1,7,1,.945.945,0,0,1,6,2,.945.945,0,0,1,5,1,.945.945,0,0,1,6,0Z" />
                                    <path id="Path_14671" data-name="Path 14671" d="M6,4A.945.945,0,0,1,7,5,.945.945,0,0,1,6,6,.945.945,0,0,1,5,5,.945.945,0,0,1,6,4Z" />
                                    <path id="Path_14672" data-name="Path 14672" d="M6,8A.945.945,0,0,1,7,9a.945.945,0,0,1-1,1A.945.945,0,0,1,5,9,.945.945,0,0,1,6,8Z" />
                                  </svg>
                                </div>
                                <div className="draggable-data-col draggable-data-title">
                                  {
                                    val.arrfled ? val.arrfled.replace(/<[^>]+>/g, '') : ''
                                  }
                                </div>
                                <div className="draggable-data-col draggable-data-action">
                                  {(wdtnm === 'job_board' || wdtnm === 'tool_team_showcase' || wdtnm === 'tool_pricing') &&
                                    <span className="btn-action nf-btn light-bg-icon btn-icon-20  tbl-action-dlt" onClick={() => ClonefieldinArw(key, wdtnm)}>
                                      <svg xmlns="http://www.w3.org/2000/svg" height="10pt" viewBox="-21 0 512 512" width="10pt">
                                        <path fill="#b0bec5" d="m186.667969 416c-49.984375 0-90.667969-40.683594-90.667969-90.667969v-218.664062h-37.332031c-32.363281 0-58.667969 26.300781-58.667969 58.664062v288c0 32.363281 26.304688 58.667969 58.667969 58.667969h266.664062c32.363281 0 58.667969-26.304688 58.667969-58.667969v-37.332031zm0 0" />
                                        <path fill="#b0bec5" d="m469.332031 58.667969c0-32.40625-26.261719-58.667969-58.664062-58.667969h-224c-32.40625 0-58.667969 26.261719-58.667969 58.667969v266.664062c0 32.40625 26.261719 58.667969 58.667969 58.667969h224c32.402343 0 58.664062-26.261719 58.664062-58.667969zm0 0" />
                                      </svg>
                                    </span>
                                  }
                                  <span className="btn-action nf-btn light-bg-icon btn-icon-20  tbl-action-dlt" onClick={() => openCloseStoryDataPanel(val, key, 'tlsdtarr')}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12.414" height="7.4" viewBox="0 0 12.414 7.4">
                                      <path id="Path_14253" data-name="Path 14253" d="M6.207,98.725A7.744,7.744,0,0,0,.1,102.13a.491.491,0,0,0,0,.587,7.74,7.74,0,0,0,6.11,3.408,7.744,7.744,0,0,0,6.11-3.405.491.491,0,0,0,0-.587A7.74,7.74,0,0,0,6.207,98.725Zm.17,6.305A2.611,2.611,0,1,1,8.812,102.6,2.613,2.613,0,0,1,6.377,105.03Zm-.079-1.2a1.406,1.406,0,1,1,1.313-1.313A1.4,1.4,0,0,1,6.3,103.827Z" transform="translate(0 -98.725)" fill="#8392a5" />
                                    </svg>
                                  </span>
                                  <span className="btn-action nf-btn  btn-delete-light  light-bg-icon btn-icon-20 tbl-action-dlt" onClick={() => deletefieldinArw(key, 'tlsdtarr')}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 176 192">
                                      <g id="Group_8307" data-name="Group 8307" transform="translate(-8)">
                                        <path id="Path_12759" data-name="Path 12759" d="M128,32V24A24.027,24.027,0,0,0,104,0H88A24.027,24.027,0,0,0,64,24v8H8V48H184V32ZM80,24a8.009,8.009,0,0,1,8-8h16a8.009,8.009,0,0,1,8,8v8H80Z" fill="#fb5360" />
                                        <path id="Path_12760" data-name="Path 12760" d="M30.467,170.651A23.976,23.976,0,0,0,54.321,192h83.358a23.976,23.976,0,0,0,23.854-21.35L174.272,56H17.728Zm87.561-99.316,15.944,1.33-8,96-15.944-1.33Zm-44.056,0,8,96-15.944,1.33-8-96Z" fill="#fb5360" />
                                      </g>
                                    </svg>
                                  </span>
                                </div>
                              </div>
                            </Draggable>
                          );
                        })

                      }
                    </Container>
                  </div>
                  :
                  <div>
                    <p className='text-center'>No record found</p>
                  </div>
                }
                <div className="text-center add-new-whatsapp-num mt-3">
                  <button type='button' className="nf-btn nf-btn-default" onClick={() => AddfieldinArw('tlsdtarr')}>
                    Add new
                  </button>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
      <div className="wdgt-slidingpanel-default wdgt-sldpnl-list wdgt-sldpnl-slideradd">
        {/*  backdropClicked={openCloseStoryDataPanel} */}
        <SlidingPanel
          type={'right'}
          isOpen={openCloseStoryData}
          size={30}>
          <div className="">
            <div className="rightbar-title">
              <button className="btn-close-rightbar" onClick={openCloseStoryDataPanel}>
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 17.181 17.09">
                  <path id="Path_232" data-name="Path 232" d="M295.416,385.5l6.292-6.292a1,1,0,0,0-1.414-1.415L294,384.089l-6.292-6.292a1,1,0,1,0-1.415,1.415l6.293,6.292-6.293,6.292a1,1,0,0,0,1.415,1.415L294,386.92l6.293,6.292a1,1,0,0,0,1.414-1.415Zm0,0" transform="translate(-285.41 -376.914)" fill="#8392a5" stroke="#8392a5" strokeWidth="1" />
                </svg>
              </button>
            </div>
            <div className="sldpnl-content-wrapper">
              <div className="sldpnl-block-content">
                <form className="edit-review-form">
                  <div className="sldpnl-inbox-editslider">
                    {objStoryData.ct_id != undefined && objStoryData.arrddnfl != undefined &&
                      <div>
                        <div className="editor-toggle customize-dropdown customize-showarrow pb-3">
                          <label className="label-title">Category</label>
                          <Dropdown className="nf-select-dropdown nf-select-defaultdd"
                            options={arrCategory}
                            value={objStoryData.ct_id}
                            onChange={(e) => handleArrayChange('ct_id', objStoryData.key, e.value)} />
                        </div>
                        {widgetDataValidator.message('Category', objStoryData.ct_id, 'required')}
                      </div>
                    }
                    {objStoryData.arrfled != undefined &&
                      <div className="editor-input header-editor-ckeditor editor-header-title editor-header-title editor-rowbdr-none pb-0">
                        <label className="label-title">{
                          arrfled[wdtnm] ? arrfled[wdtnm] : 'Title'
                        }</label>
                        <ReactQuill value={objStoryData.arrfled} className='editor-ckeditor-input hideEditor arrfled crdbg' modules={modulesQuill} formats={formatsQuill}
                          onChange={(newValue, delta, source) => {
                            if (source === 'user') {
                              handleArrayChange('arrfled', objStoryData.key, newValue);
                            }
                          }}
                          onFocus={() => {
                            handleEditorFocus('arrfled');
                          }} />
                      </div>
                    }
                    {objStoryData.arrsled != undefined &&
                      <div className="editor-input header-editor-ckeditor editor-header-title">
                        <label className="label-title">{arrsled[wdtnm] ? arrsled[wdtnm] : 'Description'}</label>
                        <ReactQuill value={objStoryData.arrsled} className='editor-ckeditor-input hideEditor arrsled crdbg' modules={modulesQuill} formats={formatsQuill}
                          onChange={(newValue, delta, source) => {
                            if (source === 'user') {
                              handleArrayChange('arrsled', objStoryData.key, newValue);
                            }
                          }}
                          onFocus={() => {
                            handleEditorFocus('arrsled');
                          }} />
                      </div>
                    }
                    {objStoryData.arrfl != undefined && wdtnm !== 'tool_number_animation' &&
                      <div className="editor-input header-editor-ckeditor editor-header-title">
                        {arrName == 'tlsctarr' ?
                          <label className="label-title">Category</label>
                          :
                          wdtnm === 'tool_team_showcase' ?
                            <label className="label-title">Email</label>
                            :
                            wdtnm === 'tool_youtube_gallery' ?
                              <label className="label-title">Channel URL</label>
                              :
                              <label className="label-title">Previous button</label>
                        }
                        <input type="text"
                          name="arrfl"
                          className="editor-input-content editor-input-fullwidth"
                          value={objStoryData.arrfl}
                          onChange={(e) => handleArrayChange('arrfl', objStoryData.key, e.target.value)} />
                        {arrName == 'tlsctarr' && widgetDataValidator.message('category name', objStoryData.arrfl, 'required')}
                      </div>
                    }
                    {objStoryData.arrfl != undefined && wdtnm === 'tool_number_animation' &&
                      <div className="editor-input header-editor-ckeditor editor-header-title">
                        <label className="label-title">Number counter</label>
                        <input type="number"
                          name="arrfl"
                          className="editor-input-content editor-input-fullwidth"
                          value={objStoryData.arrfl}
                          onChange={(e) => handleArrayChange('arrfl', objStoryData.key, e.target.value)} />
                      </div>
                    }
                    {objStoryData.arrsl != undefined &&
                      <div className="editor-input header-editor-ckeditor editor-header-title">
                        {
                          wdtnm === 'tool_team_showcase' ?
                            <label className="label-title">Phone</label>
                            :
                            <label className="label-title">Next button</label>
                        }
                        <input type="text"
                          name="arrsl"
                          className="editor-input-content editor-input-fullwidth"
                          value={objStoryData.arrsl}
                          onChange={(e) => handleArrayChange('arrsl', objStoryData.key, e.target.value)} />
                      </div>
                    }

                    {objStoryData.arrtl != undefined &&
                      <div className="editor-input header-editor-ckeditor editor-header-title">
                        <label className="label-title">Website</label>
                        <input type="text"
                          name="arrtl"
                          className="editor-input-content editor-input-fullwidth"
                          value={objStoryData.arrtl}
                          onChange={(e) => handleArrayChange('arrtl', objStoryData.key, e.target.value)} />
                      </div>
                    }
                    {objStoryData.arrtled != undefined &&
                      <div className="editor-input header-editor-ckeditor editor-header-title">
                        <label className="label-title">{arrtled[wdtnm] ? arrtled[wdtnm] : 'Salary'}</label>
                        <ReactQuill value={objStoryData.arrtled} className='editor-ckeditor-input hideEditor arrtled crdbg' modules={modulesQuill} formats={formatsQuill}
                          onChange={(newValue, delta, source) => {
                            if (source === 'user') {
                              handleArrayChange('arrtled', objStoryData.key, newValue);
                            }
                          }}
                          onFocus={() => {
                            handleEditorFocus('arrtled');
                          }} />
                      </div>
                    }
                    {objStoryData.arrfrtled != undefined &&
                      <div className="editor-input header-editor-ckeditor editor-header-title">
                        <label className="label-title">{arrfrtled[wdtnm] ? arrfrtled[wdtnm] : 'Designation'}</label>
                        <ReactQuill value={objStoryData.arrfrtled} className='editor-ckeditor-input hideEditor arrfrtled crdbg' modules={modulesQuill} formats={formatsQuill}
                          onChange={(newValue, delta, source) => {
                            if (source === 'user') {
                              handleArrayChange('arrfrtled', objStoryData.key, newValue);
                            }
                          }}
                          onFocus={() => {
                            handleEditorFocus('arrfrtled');
                          }} />
                      </div>
                    }
                    {objStoryData.arrfftled != undefined &&
                      <div className="editor-input header-editor-ckeditor editor-header-title">
                        <label className="label-title">{arrfftled[wdtnm] ? arrfftled[wdtnm] : 'Job type'}</label>
                        <ReactQuill value={objStoryData.arrfftled} className='editor-ckeditor-input hideEditor arrfftled crdbg' modules={modulesQuill} formats={formatsQuill}
                          onChange={(newValue, delta, source) => {
                            if (source === 'user') {
                              handleArrayChange('arrfftled', objStoryData.key, newValue);
                            }
                          }}
                          onFocus={() => {
                            handleEditorFocus('arrfftled');
                          }} />
                      </div>
                    }
                    {objStoryData.arrsxtled != undefined &&
                      <div className="editor-input header-editor-ckeditor editor-header-title">
                        <label className="label-title">Description</label>
                        <ReactQuill value={objStoryData.arrsxtled} className='editor-ckeditor-input hideEditor arrsxtled crdbg' modules={modulesQuill} formats={formatsQuill}
                          onChange={(newValue, delta, source) => {
                            if (source === 'user') {
                              handleArrayChange('arrsxtled', objStoryData.key, newValue);
                            }
                          }}
                          onFocus={() => {
                            handleEditorFocus('arrsxtled');
                          }} />
                      </div>
                    }

                    {objStoryData.arrchipsfl != undefined &&
                      <div className="editor-input header-editor-ckeditor editor-header-title">
                        <label className="label-title">Skill</label>
                        <input className="editor-input-content editor-input-fullwidth editor-input-inckey" type="text" placeholder='Enter word then press enter' value={jobSkillChips} onChange={(e) => handleInputchange('jobSkillChips', e.target.value)} onKeyDown={(e) => handleEnterEvent('arrchipsfl', e, objStoryData.key)}></input>
                        <div className="chips-block">
                          {
                            objStoryData.arrchipsfl.length > 0 ?
                              <ul className="chips-list">
                                {
                                  objStoryData.arrchipsfl.map((val, key) => {
                                    return (
                                      <li key={key}>{val}<i onClick={() => removeChips('arrchipsfl', key, objStoryData.key)}><img src={IconClose} /></i></li>
                                    );
                                  })
                                }
                              </ul>
                              : null
                          }
                        </div>
                      </div>
                    }

                    {objStoryData.arrctaiicn != undefined &&
                      <div className="editor-toggle customize-dropdown customize-showarrow editor-rowbdr-none">
                        <label className="label-title">Show CTA label</label>
                        <label className="switch">
                          <input type="checkbox" checked={objStoryData.arrctaiicn} onChange={(e) => handleArrayChange('arrctaiicn', objStoryData.key, e.target.checked)} />
                          <span className="slider round"></span>
                        </label>
                      </div>
                    }

                    {objStoryData.arrctalbl != undefined &&
                      <div className="editor-input header-editor-ckeditor editor-header-title  editor-rowbdr-none" style={{ marginTop: '-10px' }}>
                        <label className="label-title">CTA Label</label>
                        <input type="text"
                          name="wbstlnk"
                          className="editor-input-content editor-input-fullwidth"
                          value={objStoryData.arrctalbl}
                          onChange={(e) => handleArrayChange('arrctalbl', objStoryData.key, e.target.value)} />
                      </div>
                    }
                    {objStoryData.arrctaurl != undefined &&
                      <div className="editor-input header-editor-ckeditor editor-header-title editor-rowbdr-none mt-0">
                        <label className="label-title">CTA URL</label>
                        <input type="text"
                          name="wbstlnk"
                          className="editor-input-content editor-input-fullwidth"
                          value={objStoryData.arrctaurl}
                          onChange={(e) => handleArrayChange('arrctaurl', objStoryData.key, e.target.value)} />
                      </div>
                    }
                    {objStoryData.arrctapstn != undefined &&
                      <div className="editor-toggle customize-dropdown customize-showarrow pb-3">
                        <label className="label-title">CTA Position</label>
                        <Dropdown className="nf-select-dropdown nf-select-defaultdd"
                          options={btnPosition}
                          value={objStoryData.arrctapstn}
                          onChange={(e) => handleArrayChange('arrctapstn', objStoryData.key, e.value)} />
                      </div>
                    }
                    {objStoryData.arrctaicn != undefined &&
                      <div className="editor-input header-editor-ckeditor editor-input-upload mt-0">
                        <div className="nf-group-input  mb-0">
                          <label className="label-title">CTA icon</label>
                          <div className="icon-setting-block">
                            <div className="icon-box">
                              <img className="editor-input-content" src={objStoryData.arrctaicn} />
                            </div>
                            <div className="icon-edit cursor" onClick={() => openIconModel('arrctaicn', objStoryData.key)}>
                              <img src={IconEditImg} alt="" />
                            </div>
                          </div>
                        </div>
                      </div>
                    }

                    {objStoryData.arrdt != undefined &&
                      <div className="editor-input header-editor-ckeditor editor-input-date editor-rowbdr-none">
                        <div className="nf-group-input mb-0">
                          <label className="label-title">Publish date</label>
                          <div className="editor-inputbtn editor-enter-datepk ">
                            {/* <DatePicker
                              selected={objStoryData.arrdt ? new Date(objStoryData.arrdt) : null}
                              onChange={date => handleArrayChange('arrdt', objStoryData.key, date)}
                              className={'editor-input-content editor-input-fullwidth '}
                              dateFormat="dd/MMM/yyyy" /> */}
                          </div>
                        </div>
                      </div>
                    }
                    {objStoryData.arrdtpstn != undefined &&
                      <div className="editor-toggle customize-dropdown customize-showarrow pb-3">
                        <label className="label-title">{cnf.arrdtpstnlbl ? cnf.arrdtpstnlbl : 'Date Position'}</label>
                        <Dropdown className="nf-select-dropdown nf-select-defaultdd"
                          options={btnPosition}
                          value={objStoryData.arrdtpstn}
                          onChange={(e) => handleArrayChange('arrdtpstn', objStoryData.key, e.value)} />
                      </div>
                    }

                    {objStoryData.arrimg1 != undefined && (arrName == 'tlsctarr' || wdtnm != 'tool_restaurant') &&
                      <div className="editor-input header-editor-ckeditor editor-input-upload">
                        <div className="nf-group-input mb-0">
                          <label className="label-title">Image</label>
                          <div className="icon-setting-block">
                            {objStoryData.arrimg1 ?
                              <div className="icon-box">
                                <img className="editor-input-content" src={objStoryData.arrimg1} />
                              </div>
                              : <div className="icon-box">
                                <img className="editor-input-content" src="https://storage.googleapis.com/widget_img/widget/default_share.png" />
                              </div>
                            }
                            <div className="icon-edit cursor" onClick={() => openIconModel('arrimg1', objStoryData.key)}>
                              <img src={IconEditImg} alt="" />
                            </div>
                          </div>
                        </div>
                      </div>
                    }

                    {objStoryData.arrimg2 != undefined &&
                      <div className="editor-input header-editor-ckeditor editor-input-upload">
                        <div className="nf-group-input mb-0">
                          <label className="label-title">Image</label>
                          <div className="icon-setting-block">
                            {objStoryData.arrimg2 ?
                              <div className="icon-box">
                                <img className="editor-input-content" src={objStoryData.arrimg2} />
                              </div>
                              : <div className="icon-box">
                                <img className="editor-input-content" src="https://storage.googleapis.com/widget_img/widget/default_share.png" />
                              </div>
                            }
                            <div className="icon-edit cursor" onClick={() => openIconModel('arrimg2', objStoryData.key)}>
                              <img src={IconEditImg} alt="" />
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>

                  {/* for feedback widget */}
                  {objStoryData.arradmr && objStoryData.arradmr.length > 0 &&
                    objStoryData.arradmr.map((val, key) => {
                      return (
                        <div className="editor-review-data" key={key}>
                          {val.typ != undefined &&
                            <div className="editor-toggle customize-dropdown customize-showarrow editor-rowbdr-none">
                              <label className="label-title">Select Type</label>
                              <Dropdown className="nf-select-dropdown nf-select-defaultdd"
                                options={inputOptn}
                                value={val.typ}
                                onChange={(e) => handleChildArrayChange('typ', e.value, objStoryData.key, key)} />
                            </div>
                          }
                          {val.ilbl != undefined &&
                            <div className="editor-toggle customize-dropdown customize-showarrow editor-rowbdr-none">
                              <label className="label-title">Show label</label>
                              <label className="switch">
                                <input type="checkbox" checked={val.ilbl} onChange={(e) => handleChildArrayChange('ilbl', e.target.checked, objStoryData.key, key)} />
                                <span className="slider round"></span>
                              </label>
                            </div>
                          }
                          {val.lbl != undefined &&
                            <div className="editor-input header-editor-ckeditor editor-header-title editor-rowbdr-none" id={`${'chklblEmty_' + key}`}>
                              <label className="label-title">Label * </label>
                              <input type="text"
                                name="lbl"
                                className="editor-input-content editor-input-fullwidth"

                                value={val.lbl}
                                onChange={(e) => handleChildArrayChange('lbl', e.target.value, objStoryData.key, key)} />
                            </div>
                          }
                          {(val.typ == 'textbox' || val.typ == 'text_area') &&
                            <div className="editor-input header-editor-ckeditor editor-header-title">
                              <label className="label-title">Placeholder</label>
                              <input type="text"
                                name="plchldr"
                                className="editor-input-content editor-input-fullwidth"

                                value={val.plchldr}
                                onChange={(e) => handleChildArrayChange('plchldr', e.target.value, objStoryData.key, key)} />
                            </div>
                          }
                          {(val.typ == 'dropdown' || val.typ == 'radio_button' || val.typ == 'checkbox') &&
                            <div>
                              {
                                val.optn.length > 0 &&
                                val.optn.map((optn, optnKey) => {
                                  return (
                                    <div key={optnKey} >
                                      <div className="editor-input header-editor-ckeditor editor-header-title">
                                        <label className="label-title">Enter option</label>
                                        <input type="text"
                                          name="optn"
                                          className="editor-input-content editor-input-fullwidth"

                                          value={optn}
                                          onChange={(e) => handleChildArrayChange('optn', e.target.value, objStoryData.key, key, optnKey)} />
                                      </div>
                                      <span className="btn-action nf-btn btn-delete-light light-bg-icon btn-icon-20 tbl-action-dlt" onClick={() => deletefieldinArw(objStoryData.key, 'tlsdtarr', key, 'optn', optnKey)}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 176 192">
                                          <g id="Group_8307" data-name="Group 8307" transform="translate(-8)">
                                            <path id="Path_12759" data-name="Path 12759" d="M128,32V24A24.027,24.027,0,0,0,104,0H88A24.027,24.027,0,0,0,64,24v8H8V48H184V32ZM80,24a8.009,8.009,0,0,1,8-8h16a8.009,8.009,0,0,1,8,8v8H80Z" fill="#fb5360" />
                                            <path id="Path_12760" data-name="Path 12760" d="M30.467,170.651A23.976,23.976,0,0,0,54.321,192h83.358a23.976,23.976,0,0,0,23.854-21.35L174.272,56H17.728Zm87.561-99.316,15.944,1.33-8,96-15.944-1.33Zm-44.056,0,8,96-15.944,1.33-8-96Z" fill="#fb5360" />
                                          </g>
                                        </svg>
                                      </span>
                                    </div>
                                  );
                                })
                              }
                              <button type='button' className="nf-btn nf-btn-default" onClick={() => AddfieldinChildArw('optn', key)}>
                                Add new
                              </button>
                            </div>
                          }
                          {val.typ == 'range_slider' &&
                            <div>
                              <div className="editor-input header-editor-ckeditor editor-header-title">
                                <label className="label-title">Min</label>
                                <input type="text"
                                  name="frmrng"
                                  className="editor-input-content editor-input-fullwidth"

                                  value={val.frmrng}
                                  onChange={(e) => handleChildArrayChange('frmrng', e.target.value, objStoryData.key, key)} />
                              </div>

                              <div className="editor-input header-editor-ckeditor editor-header-title">
                                <label className="label-title">Max</label>
                                <input type="text"
                                  name="torng"
                                  className="editor-input-content editor-input-fullwidth"

                                  value={val.torng}
                                  onChange={(e) => handleChildArrayChange('torng', e.target.value, objStoryData.key, key)} />
                              </div>
                            </div>
                          }
                          {val.irqrd != undefined &&
                            <div className="editor-toggle customize-dropdown customize-showarrow">
                              <label className="label-title">Required</label>
                              <label className="switch">
                                <input type="checkbox" checked={val.irqrd} onChange={(e) => handleChildArrayChange('irqrd', e.target.checked, objStoryData.key, key)} />
                                <span className="slider round"></span>
                              </label>
                            </div>
                          }
                          {val.icn != undefined &&
                            <div className="editor-input header-editor-ckeditor editor-input-upload">
                              <div className="nf-group-input mb-0">
                                <label className="label-title">Image</label>
                                <div className="icon-setting-block">
                                  {val.icn ?
                                    <div className="icon-box">
                                      <img className="editor-input-content" src={val.icn} />
                                    </div>
                                    : <div className="icon-box">
                                      <img className="editor-input-content" src="https://storage.googleapis.com/widget_img/widget/default_share.png" />
                                    </div>
                                  }
                                  <div className="icon-edit cursor" onClick={() => openIconModel('icn', objStoryData.key, key)}>
                                    <img src={IconEditImg} alt="" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          }
                          {val.url != undefined &&
                            <div className="editor-input header-editor-ckeditor editor-header-title">
                              <label className="label-title">URL</label>
                              <input type="text"
                                name="wbstlnk"
                                className="editor-input-content editor-input-fullwidth"
                                value={val.url}
                                onChange={(e) => handleChildArrayChange('url', e.target.value, objStoryData.key, key)} />
                            </div>
                          }
                          {/* delete object */}
                          <div className="editor-delete-data-feed">
                            <span className="btn-action nf-btn btn-delete-light light-bg-icon btn-icon-20 tbl-action-dlt" onClick={() => deletefieldinArw(objStoryData.key, 'tlsdtarr', key, 'arradmr')}>
                              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 176 192">
                                <g id="Group_8307" data-name="Group 8307" transform="translate(-8)">
                                  <path id="Path_12759" data-name="Path 12759" d="M128,32V24A24.027,24.027,0,0,0,104,0H88A24.027,24.027,0,0,0,64,24v8H8V48H184V32ZM80,24a8.009,8.009,0,0,1,8-8h16a8.009,8.009,0,0,1,8,8v8H80Z" fill="#fb5360" />
                                  <path id="Path_12760" data-name="Path 12760" d="M30.467,170.651A23.976,23.976,0,0,0,54.321,192h83.358a23.976,23.976,0,0,0,23.854-21.35L174.272,56H17.728Zm87.561-99.316,15.944,1.33-8,96-15.944-1.33Zm-44.056,0,8,96-15.944,1.33-8-96Z" fill="#fb5360" />
                                </g>
                              </svg>
                            </span>
                          </div>
                        </div>
                      );
                    })
                  }
                  {
                    objStoryData.arradmr != undefined &&
                    <div className="text-center add-new-whatsapp-num mt-3">
                      <button type='button' className="nf-btn nf-btn-default" onClick={() => AddfieldinChildArw(wdtnm)}>
                        Add new
                      </button>
                    </div>
                  }
                  <div className="nf-btn-reviewup text-center mv-10">
                    <button type='button' className="nf-btn nf-btn-white nf-btn-noneBdr" onClick={openCloseStoryDataPanel}>Cancel</button>
                    <button type='button' className="nf-btn nf-btn-default nf-btn-noneBdr" onClick={handleAddUpdateWidget}>Update</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </SlidingPanel>
      </div>
    </div>
  );
};

export default StoryWidgetDataCard;


// WEBPACK FOOTER //
// ./src/components/Widget/StoryWidgetDataCard.js